export default __webpack_public_path__ + "static/media/YellowMarker.3583a65c.png";